import { Category, Listing, OfferType } from '@smg-real-estate/hg-rets-schema';

import { TopCategory, TopCategoryGroup, topCategoryGroups } from '@/helpers/listingUtils';
import { CustomerSegment } from '@/models/customerSegments';

export interface SharedApartmentVisibilityOptions {
  customerSegment?: CustomerSegment | string | null;
  offerType?: OfferType | null | '';
}

export function isSharedApartmentListing(categories: Category[] | undefined): boolean {
  return categories?.length === 1 && categories[0] === Category.SharedApartment;
}

export function isSharedApartmentTopCategoryAvailable({
  customerSegment,
  offerType,
}: SharedApartmentVisibilityOptions): boolean {
  return (
    offerType === OfferType.Rent &&
    (customerSegment === CustomerSegment.TENANT || customerSegment === CustomerSegment.OWNER)
  );
}

export function getVisibleTopCategoryGroups({
  customerSegment,
  offerType,
}: SharedApartmentVisibilityOptions = {}): Record<TopCategoryGroup, TopCategory[]> {
  const includeSharedApartment = isSharedApartmentTopCategoryAvailable({
    customerSegment,
    offerType,
  });

  return Object.fromEntries(
    Object.entries(topCategoryGroups).map(([group, categories]) => [
      group,
      includeSharedApartment
        ? categories
        : categories.filter((category) => category !== TopCategory.SHARED_APARTMENT),
    ]),
  ) as Record<TopCategoryGroup, TopCategory[]>;
}

export function getVisibleTopCategories(options?: SharedApartmentVisibilityOptions): TopCategory[] {
  return Object.values(getVisibleTopCategoryGroups(options)).flat();
}

export function applySharedApartmentListingDefaults(
  listing: Listing,
  categories: Category[],
): void {
  if (!isSharedApartmentListing(categories)) {
    return;
  }

  listing.characteristics = {
    ...listing.characteristics,
    numberOfRooms: 1,
  };
}
